module.exports = __webpack_public_path__ + "img/Mobile_Home_11.1f6baf11.png";